import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
//import HomeView from '../views/HomeView.vue'
import ClearanceView from '@/views/ClearanceView.vue'
import T86infoView from '@/views/T86infoView.vue'
import Login from '@/views/Login.vue'
import Libs from '@/views/Libs.vue'
import Fantracking from '@/views/FantrackingView.vue'
import { getCache } from '@/common/storage'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'clearance',
    component: ClearanceView
  },
  {
    path: '/t86info',
    name: 't86info',
    component : T86infoView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path:'/login',
    name:'login',
    component: Login,
  },
  {
    path: '/libs',
    name : 'libs',
    component: Libs
  },
  {
    path: '/fantracking',
    name : 'fantracking',
    component : Fantracking
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach(( to : any, from : any, next : any ) =>{
  const userInfo = getCache('userInfo')
  if( userInfo || to.name === 'login'){
    next()
  }else{
    //next({name : 'login'})
    next()
  }
})
export default router
